module.exports = __webpack_public_path__ + "img/betail.5b0e46e4.jpg";